import { Typography } from "antd";
import { PhoneButton } from "../InformationRequest/LeadButtons/PhoneButton/web";
import { OwnerLogo } from "../OwnerLogo/web";
import "./styles.less";

const { Text } = Typography;

export const OwnerInfo = ({ owner = null, id, mode, disabled=false }: { owner?: Owner; id; mode, disabled?:boolean }) => {
	if (owner == null) return null;
	return (
		<div className="owner-info">
			{/* @ts-ignore */}
			{owner?.logo && owner?.__typename !== "Individual" && (
				<OwnerLogo
					inmoLink={owner.inmoLink}
					inmoPropsLink={owner.inmoLinkProps}
					logo={owner.logo}
					name={owner.name}
					inmoFull={owner.inmofull}
				/>
			)}
			<div className="owner-data">
				<Text
					ellipsis
					className="owner-name"
					children={owner ? owner.name : ""}
					title={owner ? owner.name : ""}
				/>
				<PhoneButton id={id} type="viewPhone" mode={mode} seller icon btnType="text" disabled={disabled} />
			</div>
		</div>
	);
};
